import Modal from 'components/Modal'
import { FilterDialog } from './FilterDialog'
import useGetFilters from '../../../../../hooks/useGetAllTags'
import { settings } from 'settings'

const FilterModal = props => {
  // Props
  const {
    hasSubscription,
    handleTagsCheckboxChange,
    filteredTags,
    filterSettings,
    closeFilterSettings,
    filterDifficulty,
    handleSelectDifficulty,
    handleChangeChaptersByCourse,
    solvingModes,
    handleChangeSolvingMode,
    grileTypes,
    handleChangeGrileTypes,
  } = props

  const { coursesWithChapters } = useGetFilters()

  return (
    <Modal
      isOpen={filterSettings}
      closeModal={closeFilterSettings}
      title={'Setări grile'}
      isLocked={!hasSubscription}
      isLockedMessage={`doar filtrarea după ${settings.materie} este disponibilă fără un abonament premium`}
    >
      <FilterDialog
        hasSubscription={hasSubscription}
        filterDifficulty={filterDifficulty}
        handleSelectDifficulty={handleSelectDifficulty}
        handleTagsCheckboxChange={handleTagsCheckboxChange}
        filteredTags={filteredTags}
        solvingModes={solvingModes}
        handleChangeSolvingMode={handleChangeSolvingMode}
        grileTypes={grileTypes}
        handleChangeGrileTypes={handleChangeGrileTypes}
        handleChangeChaptersByCourse={handleChangeChaptersByCourse}
        coursesWithChapters={coursesWithChapters}
      />
    </Modal>
  )
}

export default FilterModal
